import processorsJson from "../../../../config/processors.json"
import { FRAMEWORKS, LANDING_COPY } from "../docs/catalog"

// The payment processor pages ("OpenReceive + Stripe"). Site-owned: the rows
// are config/processors.json, read by Rails too (ProcessorPage), and nothing
// here comes from the library's site contract. The directions each wizard
// hands out are assembled on the server (ProcessorDirections) from a mode's
// Part 1, the design, and the stack's synced directions.

export type ProcessorMode = {
  id: string
  label: string
  hint: string
  // The payload title's tail: "add BTC, USDT & USDC checkout to a Stripe app".
  title: string
  brief: string[]
}

export type Processor = {
  id: string
  label: string
  summary?: string
  // The site's own production claim, the page's second headline, and the
  // sentence under it. Never the Tested live badge: that one is a claim about
  // agent trials, and these pages have none.
  production?: string
  productionDetail?: string
  planned?: boolean
  modes?: ProcessorMode[]
}

// One framework the wizard offers, with the agent stack its Part 3 comes from.
export type ProcessorStack = { framework: string; label: string; stack: string }

const DATA = processorsJson as { processors: Processor[]; stacks: string[] }

export const PROCESSORS = DATA.processors
export const LIVE_PROCESSORS = PROCESSORS.filter((processor) => !processor.planned)

export const processorById = (id: string | null | undefined): Processor | null =>
  LIVE_PROCESSORS.find((processor) => processor.id === id) ?? null

// The H1 and <title> of /processors/<id>: ProcessorPage#heading on the server.
export const processorHeadline = (processor: Processor): string =>
  LANDING_COPY.processors.pageHeadline.replace(/\{label\}/g, processor.label)

// In config/processors.json's order. A framework the synced bundle does not
// carry is skipped, the same as ProcessorDirections.stacks on the server.
export const PROCESSOR_STACKS: ProcessorStack[] = DATA.stacks.flatMap((id) => {
  const framework = FRAMEWORKS.find((row) => row.id === id)
  return framework?.agentStack
    ? [{ framework: id, label: framework.label, stack: framework.agentStack }]
    : []
})

export const processorCoverPath = (processor: string, mode: string, stack: string): string =>
  `/agent-directions/${processor}/${mode}/${stack}.md`

export const processorFullPath = (processor: string, mode: string, stack: string): string =>
  `/agent-directions/${processor}/${mode}/${stack}/full.md`
